import { render, staticRenderFns } from "./handoversession.vue?vue&type=template&id=00e0dd10&"
import script from "./handoversession.vue?vue&type=script&lang=ts&"
export * from "./handoversession.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports